import { Mixin, Mixins } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Mixin
class SearchMixin extends Vue {
    protected searchString = '';
    protected remainingTime = 1500;
    protected searchTimeout!: any;
    protected searchNifString = '';
    protected searchPhoneString = '';

    public searchCallback() {
        // tslint:disable-next-line:no-console
        console.log('implement me!');
    }

    @Watch('searchString')
    public watchSearchString(newVal: string, oldVal: string) {
        const tempRemainingTime = this.remainingTime;
        if (newVal === '') {
            this.remainingTime = 0;
        }
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.searchCallback();
            this.remainingTime = tempRemainingTime;
        }, this.remainingTime);
    }

    @Watch('searchNifString')
    public watchSearchNifString(newVal: string, oldVal: string) {
        const tempRemainingTime = this.remainingTime;
        if (newVal === '') {
            this.remainingTime = 0;
        }
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.searchCallback();
            this.remainingTime = tempRemainingTime;
        }, this.remainingTime);
    }
    
    @Watch('searchPhoneString')
    public watchSearchPhoneString(newVal: string, oldVal: string) {
        const tempRemainingTime = this.remainingTime;
        if (newVal === '') {
            this.remainingTime = 0;
        }
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.searchCallback();
            this.remainingTime = tempRemainingTime;
        }, this.remainingTime);
    }

}

export default SearchMixin;
